export const types = (val: any) => {
    const prototypes = Object.prototype.toString.call(val).match(/^\[\w+\s+(\w+)\]$/i)
    return prototypes? prototypes[1].toLowerCase() : ""
}

export const isObject = (val: any) => {
    return types(val) === 'object'
}

export const isRegexp = (val: any) => {
    return types(val) === 'regexp'
}
export const isDate = (val: any) => {
    return types(val) === 'date'
}

// 是否布尔值
export const isBoolean = (val: any) => {
    return types(val) === 'boolean'
}
// 判断是否为数组
export const isArray = (val: any) => {
    return types(val) === 'array'
}
// 判断是否为数组
export const isString = (val: any) => {
    return types(val) === 'string'
}
// 判断是否为方法
export const isFunction = (val: any) => {
    return types(val) === 'function'
}
// 判断是否数字
export const isNumber = (val: any) => {
    return types(val) === 'number'
}